import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import CloseIcon from '@material-ui/icons/Close';
import { 
    Card, CardHeader, IconButton, Slide, 
    CardContent, CardActions, Button, Link 
} from "@material-ui/core";
import { getAUAIcon, APPYEAR, DATE, APPDAY } from "../common";
import "../styles/masterStyles.css";
import { isTablet } from "react-device-detect";

const AILegalStatement = props => { 
    const [_style, _setStyle] = useState({ 
        backgroundSize: !isTablet ? "cover" : "contain", 
        backgroundRepeat: 'no-repeat', 
        backgroundImage: 'white'
    });

    const [isIn, setIsIn] = useState(props.in ? props.in : false);

    if (APPYEAR() >= 2024) {
        return (<></>);
    }

    const classes='aua-bottom-banner';
    const direction="up";

    let _func = () => {
        localStorage.setItem('sasp_AILegalStatementDAY', APPDAY());
        localStorage.setItem('sasp_AILegalStatementYEAR', APPYEAR());

        return setIsIn(!isIn);
    };

    if (!isIn) {
        return (
            <div className="ai-legal-widget">
                <Link
                    onClick={() => {
                        return setIsIn(true)}
                    }
                >
                    {getAUAIcon('AUALegal')}
                </Link>
            </div>
        )
    } else {
        return (
            <>
                <div className="ai-legal-widget active">
                    <Link
                        onClick={() => {
                            return setIsIn(false)}
                        }
                    >
                        {getAUAIcon('AUALegalLeft')}
                    </Link>
                </div>

                <Slide mountOnEnter unmountOnExit
                    direction={`${direction}`}
                    in={isIn}
                    id="AILegalStatement"
                    className={`${classes} anchor active `}
                    timeout={{
                        appear: 1250,
                        enter: 500,
                        exit: 500,
                    }}
                >
                    <Card >
                        <CardHeader 
                            title={'Notice'}
                            action={
                                <IconButton
                                    className="firstButton"
                                    edge="start"
                                    aria-label="firstIcon"
                                    onClick={() => _func()}
                                    style={{backgroundColor: '#00567a', transform:"scale(0.5)"}}
                                >
                                    <CloseIcon className="headerIcons" />
                                </IconButton>
                            }
                        />

                        <CardContent style={{lineHeight: '1.333', paddingTop: '0px', paddingBottom: '0px'}}>                
                            <div>
                                <p>
                                    You are prohibited from using or uploading content you accessed through this mobile application into external applications, bots, software, or websites, including those using artificial intelligence technologies and infrastructure, including deep learning, machine learning and large language models and generative AI.
                                </p>
                            </div>
                        </CardContent>

                        {/* <CardActions>
                            <Button 
                                size="small"
                                className="aua-close-btn"
                                onClick={() => setIsIn(!isIn)}
                            >
                                Dismiss
                            </Button>
                        </CardActions> */}
                    </Card>
                </Slide>
            </>
        )
    }
};

const mapStateToProps = state => {
    const { auth, user_details } = state.auth;
    return { auth, user_details };
};

const AILegalStatementCard = connect(mapStateToProps)(withRouter(AILegalStatement));

export { AILegalStatementCard }